import { render, staticRenderFns } from "./compression-info-bjsz.vue?vue&type=template&id=fe58a0e0&scoped=true"
import script from "./compression-info-bjsz.vue?vue&type=script&lang=js"
export * from "./compression-info-bjsz.vue?vue&type=script&lang=js"
import style0 from "./compression-info-bjsz.vue?vue&type=style&index=0&id=fe58a0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe58a0e0",
  null
  
)

export default component.exports